import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(/* forceRefresh= */ true);
}

export const fetchSuggestions = async (category) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-vid-ideas`,
      { category },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching video suggestions:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania odpowiedzi. Spróbuj ponownie później.'
    );
  }
};

export const fetchSuggestionDetails = async (title, description) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-vid-ideas-details`, // <-- zaktualizowana nazwa endpointu
      { title, description },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching video details:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania szczegółów. Spróbuj ponownie później.'
    );
  }
};